var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { "font-size": "12px" } }, [
    _vm._v("系统已登录成功，正在跳转，请稍等...")
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }